export default function organizationfields(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                organizationfield: action.organizationfield,
            }
        case 'ADD_CURRENT_ORGANIZATION':
            return {
                ...state,
                organizationfield: action.organizationfield,
                organization: action.organization,

            }

        default:
            return state;
    }
}
